import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';
import { AUTH_API_BASE, LocalStorageTokenStore, TOKEN_STORE } from './token-store';

/**
 * Registers the web token store (and optional API base). The app wires the
 * interceptor itself: `provideHttpClient(withInterceptors([authInterceptor]))`.
 *
 * @example
 * providers: [
 *   provideHttpClient(withInterceptors([authInterceptor])),
 *   provideAuth({ apiBase: '/api' }),
 * ]
 */
export function provideAuth(options?: { apiBase?: string }): EnvironmentProviders {
  const providers: Provider[] = [{ provide: TOKEN_STORE, useClass: LocalStorageTokenStore }];
  if (options?.apiBase) {
    providers.push({ provide: AUTH_API_BASE, useValue: options.apiBase });
  }

  return makeEnvironmentProviders(providers);
}
